
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobile-apps",
      function () {
        return require("private-next-pages/mobile-apps.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobile-apps"])
      });
    }
  